import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { PlanetSportBetCompliancePopupLogo } from 'src/assets/logos/compliancePopup/PlanetSportBetCompliancePopupLogo';
import { PlanetSportBetLogo } from 'src/assets/logos/PlanetSportBetLogo';
import { PlanetSportBrandIcon } from 'src/assets/brandIcons/PlanetSportBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const PlanetSportMainLogoWrapper = withConfig(theme => styled('div', { label: 'PlanetSportMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
    padding: 20px 16px;
`);

export const PlanetSportMainLogo = styled(PlanetSportBetLogo, { label: 'PlanetSportMainLogo' })`
    width: 112px;
    margin: 0 auto;
`;

export const PlanetSportBrandIconWrapper = styled(PlanetSportBrandIcon, { label: 'PlanetSportBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(PlanetSportBetCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
